/* eslint-disable */
// https://awik.io/determine-color-bright-dark-using-javascript/
 export function isDarkColor(color) {
    // Variables for red, green, blue values
    let r; let g; let b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
      // If RGB --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      // If hex --> Convert it to RGB: http://gist.github.com/983661
      color = +(`0x${color.slice(1).replace(
        color.length < 5 && /./g, '$&$&',
      )}`);

      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
      0.299 * (r * r)
      + 0.587 * (g * g)
      + 0.114 * (b * b),
    );

    // Using the HSP value, determine whether the color is light or dark
    return hsp <= 127.5;
  }
  /* eslint-enable */
/**
 * Determine the text color depend of the machine entry event color
 * @return {string}
 * @param color
 */
export function makeTextReadable(color, suffix = true) {
  const readableColor = isDarkColor(color) === true
    ? 'white' : 'black';
  if (suffix) return `text-${readableColor}`;
  return readableColor;
}

/**
 * Perceived luminance (0-255) of a hex color, null when the color is not a 6-digit hex.
 * @param {String} color
 * @returns {number|null}
 */
export function getLuminance(color) {
  const match = /^#?([0-9a-f]{6})$/i.exec(color ?? '');
  if (!match) return null;
  const [red, green, blue] = [0, 2, 4].map((i) => parseInt(match[1].slice(i, i + 2), 16));

  return (0.299 * red) + (0.587 * green) + (0.114 * blue);
}

/**
 * Luminance above which white text is unreadable: black text is used instead.
 */
export const LIGHT_BACKGROUND_LUMINANCE = 150;
